import { HimuraInject } from 'himura';

@HimuraInject.NamedService('CommonConfig')
export class CommonConfig {

    public appTitle: string = 'RIFO Radar Dev Env Test';
    public apiHost: string = 'http://uat-api.realjaja.com/radar-api';

    public cmaPicturePlaceHolder = 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/cma-default.jpg';

    public authoreyHost: string = 'http://uat-api.realjaja.com/authorey';

    public microServHost: string = 'http://uat-service.realjaja.com';

    public cmaHost: string = 'https://ricenter.realjaja.com/cma-api';

    public microServHostAvatar = 'http://uat-service.realjaja.com/microservices-dao/pgdao/getagentimage';

    public cimsServHost: string = 'http://uat-api.realjaja.com';

    public amazonCommunityHost: string = 'https://i42kjcxyr2.execute-api.us-east-1.amazonaws.com/dev';

    public dailyReportUrl: string = 'http://www.uat.rifo.co/daily-report';

    public notFoundPlaceHolder: string = 'http://onepiece-test-oss.oss-us-west-1.aliyuncs.com/epic-test/imgs/2x/placeholders/house_placeholder%402x.png';

    public storeBannerPlaceHolder: string = 'http://onepiece-test-oss.oss-us-west-1.aliyuncs.com/epic-test/imgs/epic-banners/img01.png';

    public storeAddress: string = '.uat.rifo.co';

    public storeProtocol: string = 'http://';

    public googleAppKey: string = 'AIzaSyBQ5QtkRuPhfscwJzvMKRG2_JkaeGYvHgA';

    public analysisService: string = 'http://uat-service.realjaja.com/microservices-analysis';

    // public apiHost: string = 'http://192.168.0.125:9528/radar-api/api/v1.1';

    public dingTalk = {
        corpId: 'dingeed64b699172161e35c2f4657eb6378f'
    };

    public dateFormat = 'YYYY-MM-DD';
    public timeFormat = 'HH:mm:ss';
    public dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';

    public weekdays: string[] = [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ];

    constructor() { }
}
